import { render, staticRenderFns } from "./UrineManagement.vue?vue&type=template&id=4e859e90&scoped=true"
import script from "./UrineManagement.vue?vue&type=script&lang=js"
export * from "./UrineManagement.vue?vue&type=script&lang=js"
import style0 from "./UrineManagement.vue?vue&type=style&index=0&id=4e859e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e859e90",
  null
  
)

export default component.exports